// extracted by mini-css-extract-plugin
module.exports = {"digitInput":"DigitInput_digitInput__2EvhV"};